import { convert, LocalDate, LocalDateTime, LocalTime, ZonedDateTime } from '@js-joda/core'
import i18next from 'i18next'
import LocalDateConverter from '@migrate/utils/date/LocalDateConverter'
import LocalDateTimeConverter from '@migrate/utils/date/LocalDateTimeConverter'
import ZonedDateTimeConverter from '@migrate/utils/date/ZonedDateTimeConverter'

export default class IsoStringConverter {
  private value: string

  constructor(value: string) {
    this.value = value
  }

  public toNative(): Date {
    return convert(this.toLocalDate()).toDate()
  }

  public toLocalDate(): LocalDate {
    return LocalDate.parse(this.value)
  }

  public toLocalDateTime(): LocalDateTime {
    return LocalDateTime.parse(this.value)
  }

  public toLocalTime(): LocalTime {
    return LocalTime.parse(this.value)
  }

  public toLocalizedDateString(locale: string | string[] = i18next.language): string {
    return new LocalDateConverter(this.toLocalDate()).toLocalizedString(locale)
  }

  public toLocalizedDateTimeString(locale: string | string[] = i18next.language): string {
    return new LocalDateTimeConverter(this.toLocalDateTime()).toLocalizedString(locale)
  }

  public toZonedDateTime(): ZonedDateTime {
    return ZonedDateTime.parse(this.value)
  }

  public toLocalizedZonedDateTimeString(locale: string | string[] = i18next.language): string {
    return new ZonedDateTimeConverter(this.toZonedDateTime()).toLocalizedString(locale)
  }
}
